// modalStore.js
import { writable } from "svelte/store";

export const showModal = writable(false);
